import { BaseConfirmationDialog } from '@plato/ui-legacy/components/dialog/confirmation-dialog';
import { DialogStateManager, useDialog } from '@plato/ui-legacy/components/dialog/dialog-provider';
import { RadioList, RadioListItem } from '@plato/ui-legacy/components/ui/button-radio-list';
import { CalendarIcon } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ModalInnerProps } from '../../modal/index.tsx';

export type DragScopeChoice = 'single' | 'update-schedule';

export type DragRecurrenceScopeDialogProps = {
    onConfirm: (choice: DragScopeChoice) => void;
    onCancel?: () => void;
} & ModalInnerProps;

export const DragRecurrenceScopeDialog = DialogStateManager.create<DragRecurrenceScopeDialogProps>(
    ({ onConfirm, onCancel }: DragRecurrenceScopeDialogProps) => {
        const { t } = useTranslation();
        const modal = useDialog();
        const [choice, setChoice] = React.useState<DragScopeChoice>('single');

        const handleConfirm = () => {
            onConfirm(choice);
            modal.remove();
        };

        const handleCancel = () => {
            onCancel?.();
            modal.remove();
        };

        return (
            <BaseConfirmationDialog
                title={t('events__drag_scope__title', { ns: 'events' })}
                description={t('events__drag_scope__body', { ns: 'events' })}
                icon={CalendarIcon}
            >
                <div className="self-start">
                    <RadioList
                        value={choice}
                        onValueChange={(val) => {
                            setChoice(val as DragScopeChoice);
                        }}
                    >
                        <RadioListItem
                            value="single"
                            label={t('events__drag_scope__single', { ns: 'events' })}
                        />
                        <RadioListItem
                            value="update-schedule"
                            label={t('events__drag_scope__update_schedule', { ns: 'events' })}
                        />
                    </RadioList>
                </div>
                <BaseConfirmationDialog.Actions>
                    <BaseConfirmationDialog.RejectButton onClick={handleCancel}>
                        {t('form__cancel')}
                    </BaseConfirmationDialog.RejectButton>
                    <BaseConfirmationDialog.AcceptButton onClick={handleConfirm}>
                        {t('events__drag_scope__confirm', { ns: 'events' })}
                    </BaseConfirmationDialog.AcceptButton>
                </BaseConfirmationDialog.Actions>
            </BaseConfirmationDialog>
        );
    },
);
